import { useContext, useRef, useState } from 'react';

import { emptyFn } from '@app/constants';
import { RecordModalContext } from '@app/providers/RecordModalProvider/RecordModalContext';
import type { RecordModalProviderProps } from '@app/providers/RecordModalProvider/RecordModalProvider.types';

import type { FC } from 'react';

export const RecordModalProvider: FC<RecordModalProviderProps> = ({
  children,
}) => {
  const [isCommentModal, setIsCommentModal] = useState(false);
  const [isNeedToUpdateRecordsRegistry, setIsNeedToUpdateRecordsRegistry] =
    useState<boolean>(false);
  const onConfirmRef = useRef<() => void>(emptyFn);
  const onAfterSaveRef = useRef<() => void | Promise<void>>(emptyFn);

  return (
    <RecordModalContext.Provider
      value={{
        isNeedToUpdateRecordsRegistry,
        setIsNeedToUpdateRecordsRegistry,
        isCommentModal,
        setIsCommentModal,
        onConfirmRef,
        onAfterSaveRef,
      }}
    >
      {children}
    </RecordModalContext.Provider>
  );
};

export const useRecordModalContext = () => {
  const context = useContext(RecordModalContext);
  if (!context) {
    throw new Error(
      'useRecordModalContext must be used within a RecordModalProvider'
    );
  }
  return context;
};
